<div class="dtf-accountdetails admin-banners-page">
  <div class="dtf-alertpage"></div>
  <br>
  <div class="container_dashboard">
  <div class="cardlike">
  <h1 class="mercedes-me-login__column-headline2">Manage Banners</h1>
  <p class="paragraph1">Important: Please test all changes in the staging environment before applying them to production.Ensure you back up the existing content, as any updates will overwrite the current copy and cannot be undone.All changes are pushed to the website immediately.</p>
  <br> <br>
  </div>
  <br>
  <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner loading-container">
    <!--Spinner on Login Load-->
    <div class="demo-container">
      <span>{{ 'Invoice.Loading' | translate }}</span>
      <div class="progress-bar">
        <div class="progress-bar-value"></div>
      </div>
    </div>
    <br>
  </div>
  <div class="table-wrapper">
  <mat-table [dataSource]="dataSource" class="mat-elevation-z8 banner-table" matSort>

    <ng-container [matColumnDef]="column.name" *ngFor="let column of initColumns">
      
      <mat-header-cell mat-sort-header *matHeaderCellDef [attr.colspan]="column.colspan" class="banner-header-cell">
        {{ isFrench ? column.displayFR : column.display }}
      </mat-header-cell>

      <mat-cell *matCellDef="let element" class="banner-data-cell">
        <!-- Editable Input -->
        <div *ngIf="column.dispFormat === 'editable'" class="editable-field">
          <mat-form-field appearance="outline" class="editor-field">
            <mat-label>Edit Value</mat-label>
            <input matInput [(ngModel)]="element[column.name]" [value]="element[column.name]" />
          </mat-form-field>
        </div>
      
        <!-- Editable Textarea -->
        <div *ngIf="column.dispFormat === 'editablecopy'" class="editable-field">
          <mat-form-field appearance="outline" class="editor-field">
            <mat-label>Edit Banner Copy</mat-label>
            <textarea matInput [(ngModel)]="element[column.name]" rows="3">
          </textarea>
          </mat-form-field>
        </div>

        <!-- Scheduler Date Picker -->
        <div *ngIf="column.dispFormat === 'datepicker'" class="editable-field">
          <mat-form-field appearance="outline" class="editor-field">
            <mat-label>{{ column.display }} &amp; Time</mat-label>
            <input
              matInput
              type="datetime-local"
              [ngModel]="toDateTimeLocalValue(element[column.name])"
              (ngModelChange)="onDateTimeChange(element, column.name, $event)"
            />
          </mat-form-field>
        </div>

        <div *ngIf="column.dispFormat === ''">
          {{ element[column.name] }}
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="alerts">
      <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
        [attr.colspan]="displayedColumns.length">
      </mat-cell>
    </ng-container>
    <!-- ✅ REQUIRED -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  
  </mat-table>
  </div>
  <mat-paginator [pageSizeOptions]="[5,10, 25, 100]"></mat-paginator>
<!-- Save Button -->
<div class="save-row-wrap">
  <div class="save-row mt-4">
    <button class="mbfs-button" (click)="saveData()">Save</button>
    <div *ngIf="successMessage" class="success-banner">
      {{ successMessage }}
    </div>
  </div>
</div>
</div>